import type { NationalProgram } from '../types';

export type ProgStatus = 'on-track' | 'at-risk' | 'off-track';

/** Delivery ratio = actual progress vs planned progress (%). */
export function programRatio(p: NationalProgram): number {
  return p.planned > 0 ? Math.round((p.progress / p.planned) * 100) : 100;
}

export function programStatus(p: NationalProgram): ProgStatus {
  const r = programRatio(p);
  if (r >= 100) return 'on-track';
  if (r >= 90) return 'at-risk';
  return 'off-track';
}

/** Maps a program status to the shared pill style classes. */
export function programPill(status: ProgStatus): 'excellent' | 'watch' | 'act' {
  return status === 'on-track' ? 'excellent' : status === 'at-risk' ? 'watch' : 'act';
}

export function programCounts(programs: NationalProgram[]): Record<ProgStatus, number> {
  return programs.reduce(
    (acc, p) => {
      acc[programStatus(p)] += 1;
      return acc;
    },
    { 'on-track': 0, 'at-risk': 0, 'off-track': 0 } as Record<ProgStatus, number>,
  );
}

/** Overall delivery = mean of program progress. */
export function overallDelivery(programs: NationalProgram[]): number {
  if (programs.length === 0) return 0;
  return Math.round(programs.reduce((s, p) => s + p.progress, 0) / programs.length);
}
